module.exports = __webpack_public_path__ + "static/media/scr_onboarding_02_chat.4bf588db.png";